import { useCallback } from "react"

import { useFocusEffect } from "expo-router"

/** Runs load when the screen gains focus (including first mount). */
export function useLoadOnFocus(load: () => void | Promise<void>) {
  useFocusEffect(
    useCallback(() => {
      void load()
    }, [load]),
  )
}
